import * as React from 'react';
import {connect} from 'react-redux';
import {IFamilyMember, IFamilyMemberFileIdUpdate} from '@app-types/websocket/family.types';
import {WithStyles, withStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import {childinfoStyle} from './childinfo.style';
import {FamilyMemberType} from '@services/family/family.constants';
import * as FamilyActions from '@services/family/family.actions';
import ChildInfo from './ChildInfo';
import {IChildInfo, IChildInfoUpdate} from '@app-types/websocket/sharedinfo.types';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof childinfoStyle> {
  userRole: FamilyMemberType;
  userId: number;
  family: IFamilyMember[];
  childInfo: IChildInfo[];
  updateChildInfo: (data: IChildInfoUpdate) => void;
  updateFamilyMember: (data: IFamilyMember) => void;
  updateFamilyMemberFileId: (data:IFamilyMemberFileIdUpdate) => void;
}

class ChildInfoList extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const {classes} = this.props;

    const kids: JSX.Element[] = [];
    for (const mem of this.props.family) {
      if (mem.role === FamilyMemberType.CHILD) {
        const childInfo = this.props.childInfo.find((childI) => childI.accountId === mem.id);
        kids.push(<ChildInfo
          key={mem.id}
          child={mem}
          userId={this.props.userId}
          family={this.props.family}
          userRole={this.props.userRole}
          childInfo={childInfo}
          updateFamilyMember={this.props.updateFamilyMember}
          updateFamilyMemberFileId={this.props.updateFamilyMemberFileId}
          updateChildInfo={this.props.updateChildInfo}/>);
      }
    }

    return (
      <div className={classes.root}>
        <div className={classes.kidsList}>
          {kids}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  const family: IFamilyMember[] = state.family.family;
  const childInfo = state.family.childInfo;
  let userRole = FamilyMemberType.VIEWER;
  for (const mem of family) {
    if (mem.id === userId) {
      userRole = mem.role;
    }
  }
  return {
    userRole,
    family,
    userId,
    childInfo,
  };
}

const mapDispatchToProps = {
  updateChildInfo: FamilyActions.updateChildInfo,
  updateFamilyMemberFileId: FamilyActions.updateFamilyMemberFileId,
  updateFamilyMember: FamilyActions.updateFamilyMember,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(childinfoStyle)(ChildInfoList));



// WEBPACK FOOTER //
// ./src/components/childinfo/ChildInfoList.tsx